import React, {useEffect, useState} from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import {ResolvedOrgProvider} from '../../context/ResolvedOrgContext';
import {resolveOrgContextFromLocation} from '../../services/domainService';
import {getReturnTo} from '../../utils/authRedirect';
import {boundedOrganizationResolution} from '../../utils/organizationResolution';
import {connectionFailure} from '../../utils/connectionErrors';

// Auth routes are siblings of the website shell; resolve their custom-domain
// identity through the same public domain boundary, including first visits.
export default function CustomDomainAuthBoundary({children, register = false}) {
  const location=useLocation();
  const [state,setState]=useState({loading:true,context:null,error:false});
  const [attempt,setAttempt]=useState(0);
  useEffect(()=>{
    const retry=()=>{if(state.error && !state.loading)setAttempt(n=>n+1);};
    window.addEventListener('online',retry);
    return()=>window.removeEventListener('online',retry);
  },[state.error,state.loading]);
  useEffect(()=>{
    let active=true;
    setState({loading:true,context:null,error:false});
    boundedOrganizationResolution(()=>resolveOrgContextFromLocation({hostname:window.location.hostname,pathname:location.pathname}))
      .then(context=>{if(active)setState({loading:false,context,error:context?.orgSlug ? false : 'missing'});})
      .catch(error=>{if(active)setState({loading:false,context:null,error:connectionFailure(error)});});
    return()=>{active=false;};
  },[location.pathname,attempt]);
  if(state.loading)return <main className="p-6" role="status">Loading your organization…</main>;
  if(state.error)return <main className="p-6" role="alert">{state.error === 'missing' ? 'This organization’s sign-in page is unavailable.' : state.error === 'verification' ? 'Security verification could not finish. Please try again.' : 'We couldn’t connect to your organization. Please try again.'}<button type="button" className="ml-3 underline" onClick={()=>setAttempt(n=>n+1)}>Try again</button></main>;
  if(register){const params=new URLSearchParams({mode:'register',org:state.context.orgSlug});const target=getReturnTo(location,'');if(target)params.set('returnTo',target);return <Navigate to={`/login?${params}`} replace/>;}
  return <ResolvedOrgProvider value={state.context}>{children}</ResolvedOrgProvider>;
}
